import { render, staticRenderFns } from "./DashboardSidebarNavigation.vue?vue&type=template&id=349f9fcb&scoped=true"
import script from "./DashboardSidebarNavigation.vue?vue&type=script&lang=js"
export * from "./DashboardSidebarNavigation.vue?vue&type=script&lang=js"
import style0 from "./DashboardSidebarNavigation.vue?vue&type=style&index=0&id=349f9fcb&prod&lang=scss&scoped=true"
import style1 from "./DashboardSidebarNavigation.vue?vue&type=style&index=1&id=349f9fcb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349f9fcb",
  null
  
)

export default component.exports